import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private httpClient: HttpClient) { }
  uploadFile = (file: File, foldername: string): Observable<any> => {
    const formData = new FormData();
    formData.append(file.name, file);
    return this.httpClient.post(
      ApiConstants.Files_Upload_Api + foldername, formData);
  }
  downloadFile = (fileId: string)
    : Observable<any> => {
    return this.httpClient.get(ApiConstants.Files_Download_Api + `${fileId}`);
  }
  // To DO : Need to integrate with file service
  deleteFile = (fileId: string)
    : Observable<any> => {
    return of(true);
  }

  downloadFileByName = (folderName: string, fileName: string): Observable<any> => {
    return this.httpClient.get(`${ApiConstants.FileDownloadByName_Api}${folderName}/${fileName}`);
  }
}
